import React, { useEffect, useState } from "react";
import CircularProgress from "../CircularProgress";
import {message as toastNotification} from "antd";
import Auxiliary from "../../util/Auxiliary";

const AppNotificationContainer = ({loading, error, message}) => {
  const [messageQueue, setMessageQueue] = useState([]);
  const [errorQueue, setErrorQueue] = useState([]);

  useEffect(() => {
    if (message && message.trim()) {
      const messageId = Date.now() + Math.random();
      setMessageQueue(prev => [...prev, { id: messageId, text: message }]);
      
      // Show the message
      toastNotification.success({
        content: <span id={`message-id-${messageId}`}>{message}</span>,
        key: messageId,
        duration: 4,
      });

      // Remove from queue after display
      setTimeout(() => {
        setMessageQueue(prev => prev.filter(msg => msg.id !== messageId));
      }, 4000);
    }
  }, [message]);

  useEffect(() => {
    if (error && error.trim()) {
      const errorId = Date.now() + Math.random();
      setErrorQueue(prev => [...prev, { id: errorId, text: error }]);
      
      // Show the error message
      toastNotification.error({
        content: <span id={`error-id-${errorId}`}>{error}</span>,
        key: errorId,
        duration: 6, // Error messages stay longer
      });

      // Remove from queue after display
      setTimeout(() => {
        setErrorQueue(prev => prev.filter(err => err.id !== errorId));
      }, 6000);
    }
  }, [error]);

  return (
    <Auxiliary>
      {loading && <div className="gx-loader-view gx-loader-position">
        <CircularProgress/>
      </div>}
    </Auxiliary>
  )
}

export default AppNotificationContainer;
